import Vue from 'vue'
import App from './App.vue'
import router from './router'

import Buefy from 'buefy'
Vue.use(Buefy);

Vue.config.productionTip = false;

import VueAnalytics from 'vue-analytics'
Vue.use(VueAnalytics, {
    id: 'UA-164274513-2',
    router,
    disabled: function check() {
        const gaCookie = localStorage.getItem("cookie:accepted");
        if (gaCookie === "true") {
            return false
        } else {
            return true
        }
    },
    debug: {
        enabled: false
    }
});


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
